<template>
  <QueryView
    ref="queryView"
    :table-config="tableConfig"
    :town-selection="false"
    :region-selection="true"
    :province-selection="true"
    :has-pdf="true"
    use-expansion
  >
    <template #expansion="{ data }">
      <div
        class="query__expansion-container"
      >
        <QueryExpansionField
          field-name="Gastronomía"
          :field-value="data.gastronomy"
        />
        <QueryExpansionField
          field-name="Alojamiento"
          :field-value="data.accommodation"
        />
      </div>
    </template>
  </QueryView>
  <div
    :hidden="!dialogVisible"
    class="modal"
  >
    <div>
      <button
        class="close-button"
        @click="closeDialog"
      >
        <span class="material-icons">close</span>
      </button>
    </div>
    <DataView
      v-if="!!selectedIdStops"
      v-bind="tableStopsConfig"
      ref="dataView"
      class="dataViewClass"
      @refreshed="checkRefreshedValues()"
    >
      <template #table__fotoUrl__body="{ data }">
        <slot
          name="field__fotoUrl"
          :data="data"
        >
          <div
            v-if="!!data?.fotoUrl"
            class="query-photos-view__photo--mini"
          >
            <img
              :src="data.fotoUrl"
              @click="goPhoto(data)"
            />
          </div>
        </slot>
      </template>
      <template #list__fotoUrl="{ data }">
        <slot
          name="field__fotoUrl"
          :data="data"
        >
          <div
            v-if="!!data?.fotoUrl"
            class="query-photos-view__photo--mini"
          >
            <img
              :src="data.fotoUrl"
              @click="goPhoto(data)"
            />
          </div>
        </slot>
      </template>
    </DataView>
  </div>
  <div
    :hidden="!dialogPhotoVisible"
    class="modalPhoto"
  >
    <div>
      <button
        class="close-button"
        @click="closePhotoDialog"
      >
        <span class="material-icons">close</span>
      </button>
      <img
        :src="photoUrlAux"
        :alt="photoUrlAux"
      />
    </div>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryExpansionField from '@/components/query-expansion-field/QueryExpansionField';
import QueryTableConfig from '../query-table.view-config.js';
import {TOURIST_ROUTES_SCHEMA} from './query-tourist-routes-table.view-config';
import QueryStopsTableConfig from './tourist-routes-stops.view-config.js';
import {
  searchTouristRoute,
  viewTouristRoutePdf,
} from '@/api/tourist-route/tourist-route.api.js';
import {
  searchTouristRouteHtml,
  searchTouristRoutePdf,
  getTouristRoutePdf,
} from '@/api/tourist-route/tourist-route.api.pdf.js';
import {DataView} from '@sttedra_ui/framework';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const dialogVisible = ref(false);
const dataView = ref();
const dialogPhotoVisible = ref(false);
let photoUrlAux = '';
const {copy} = useClipboard();
const selectedIdStops = ref(0);
const tableStopsConfig = computed(() => {
  return new QueryStopsTableConfig({stopId: selectedIdStops.value});
});
// #endregion

// #region Functions
async function goTouristRoute({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 10;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}
function touristRouteToText({
  name,
  province,
  region,
  itinerary,
  gastronomy,
  accommodation,
  kms,
}) {
  const res = `
    Nombre: ${name}
    Provincia: ${province}
    Comunidad Autónoma: ${region}
    Itinerario: ${itinerary}
    Gastronomía: ${gastronomy}
    Alojamiento: ${accommodation}
    Kms: ${kms}
    `;
  return res;
}
// #endregion
async function printTouristRoute(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(
      data.id,
      'Ruta turística - ' + data.name,
      getTouristRoutePdf,
    );
  }
}
async function htmlTouristRouteQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery(
      'Informe Rutas turísticas',
      searchTouristRouteHtml,
      'html',
    );
  }
}
async function printTouristRouteQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Rutas turísticas', searchTouristRoutePdf);
  }
}
function downloadPdfFunction(row) {
  viewTouristRoutePdf(row.id);
}
async function viewStopsFunction(row) {
  dialogVisible.value = true;
  selectedIdStops.value = row.id;
}
async function closeDialog() {
  dialogVisible.value = false;
  selectedIdStops.value = 0;
}
function checkRefreshedValues() {
  if (window.screen.width <= 576) {
    setTimeout(() => (dataView.value.state$$.viewRef = 'list'), 100);
  }
}
function closePhotoDialog() {
  dialogPhotoVisible.value = false;
}
function goPhoto(data) {
  photoUrlAux = data.fotoUrl;
  dialogPhotoVisible.value = true;
}
// functions previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchTouristRoute,
  recordToText: touristRouteToText,
  copyClipboard: copy,
  htmlQuery: htmlTouristRouteQuery,
  printQuery: printTouristRouteQuery,
  printRecord: printTouristRoute,
  centerMap: goTouristRoute,
  downloadPDF: downloadPdfFunction,
  viewStops: viewStopsFunction,
  schema: TOURIST_ROUTES_SCHEMA,
});
// #endregion
</script>

<style lang="scss" scoped>
.modal {
  background-color: white;
  padding: 1rem;
  border-radius: 5px;
  position: fixed;
  right: 10%;
  bottom: 10%;
  top: 10%;
  left: 10%;
  z-index: 100;
  box-shadow: 0 1px 4px rgba($brand__color--black, 0.2);
  @media only screen and (max-width: 670px) {
    right: 3%;
    bottom: 10%;
    top: 10%;
    left: 3%;
  }
}
.modalPhoto {
  background-color: white;
  position: fixed;
  padding-top: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  top: 10%;
  left: 35%;
  border-radius: 5px;
  box-shadow: 0 1px 4px rgba($brand__color--black, 0.2);
  z-index: 400;
  @media only screen and (max-width: 670px) {
    padding-top: 1rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-bottom: 0.5rem;
    top: 10%;
    left: 0%;
    right: 0%;
  }
}
.close-button {
  float: right;
  cursor: pointer;
  border: none;
  color: rgba($brand__color--blue, 0.8) !important;
  background-color: transparent;
}
.dataViewClass {
  & :deep(.paginator) {
    display: none;
  }
  & :deep(.data-view__info__sort-by) {
    display: none;
  }
  & :deep(.data-view__header__after) {
    display: none;
  }
  & :deep(.data-view__header) {
    display: none;
  }
  & :deep(.smart-content__title) {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  & :deep(.data-view-table__field) {
    white-space: normal;
    padding: 0.6rem;
    line-height: 1.5em;
    height: 3em;
  }
}
.query-photos-view {
  &__photo {
    margin: 1rem auto;
    &--big {
      width: 95%;
      & img {
        cursor: pointer;
        display: block;
        margin: 1rem auto;
        max-width: 100%;
      }
    }
    &--mini {
      & img {
        cursor: pointer;
        max-width: 70px;
        max-height: 70px;
      }
    }
  }
}
</style>
